import axios from "axios";
import {
  clearAuthSession,
  getStoredExpiration,
  getStoredToken,
  touchSessionExpiration,
} from "./authStorage";

export const axiosObject = axios.create();

const PUBLIC_AUTH_PATHS = [
  "/user/login",
  "/user/login/otp/request",
  "/user/login/otp/verify",
  "/user/register",
  "/user/forgot_password",
  "/user/reset_password",
  "/hospital/tenants",
];

const isPublicAuthPath = (url?: string) => {
  if (!url) {
    return false;
  }
  return PUBLIC_AUTH_PATHS.some((path) => {
    const index = url.indexOf(path);
    if (index === -1) {
      return false;
    }
    const after = url[index + path.length];
    return after === undefined || after === "?" || after === "/" || after === "#";
  });
};

axiosObject.interceptors.request.use(
  (config) => {
    if (!isPublicAuthPath(config.url)) {
      const token = getStoredToken();
      const expirationTime = getStoredExpiration();
      if (token && expirationTime && Date.now() < Number(expirationTime)) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
        touchSessionExpiration();
      } else {
        clearAuthSession();
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosObject;
